import { render, staticRenderFns } from "./slideVerify.vue?vue&type=template&id=0ec18ed5&scoped=true"
import script from "./slideVerify.vue?vue&type=script&lang=js"
export * from "./slideVerify.vue?vue&type=script&lang=js"
import style0 from "./slideVerify.vue?vue&type=style&index=0&id=0ec18ed5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec18ed5",
  null
  
)

export default component.exports